import * as React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import './graphCard.css';
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonGrid, IonRow } from '@ionic/react';
import { useWindowDimensions } from '../../../../hooks/useWindowDimensions';
import { useEffect, useState } from 'react';

type ScissorsGraphCardProps = {
  series: any;
  title: string;
  x: string;
  x2: string;
  colors: string[];
};

export const ScissorsGraphCard = ({ series, title, x, x2, colors }: ScissorsGraphCardProps) => {
  const { width, height } = useWindowDimensions();
  const [windowSize, setWindowSize] = useState('small');

  useEffect(() => {
    if (height != null) {
      if (height > 860) {
        setWindowSize('large');
      } else {
        setWindowSize('small');
      }
    }
  }, [width]);
  const options: ApexOptions = {
    chart: {
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      offsetX: -10,
    },
    xaxis: {
      type: 'numeric',
      labels: {
        style: {
          fontSize: '8px',
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value: number) {
          return value.toFixed(0);
        },
        style: {
          fontSize: '8px',
        },
      },
    },
    // title: {
    //   text: title,
    //   align: 'center',
    //   style: {
    //     fontSize: '14px',
    //     fontWeight: 'bold',
    //     fontFamily: 'Montserrat',
    //     color: '#2066FA',
    //   },
    // },

    stroke: {
      width: [1, 1],
      dashArray: [4, 0],
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      fontSize: '9px',
      markers: {
        width: 8,
        height: 8,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      offsetY: 10,
    },
    colors: colors,
    annotations: {
      xaxis: [
        {
          x: x,
          x2: x2,
          borderColor: '#00E396',
          fillColor: '#ABF263',
        },
      ],
    },
    markers: {
      size: [0, 0, 2],
      strokeWidth: 0,
      showNullDataPoints: false,
    },
    tooltip: {
      enabled: false,
    },
  };

  return (
    <IonCard className='ORYX_GraphCard'>
      <IonCardHeader className='attractorCard_Header' style={{ height: '35px' }}>
        <IonGrid fixed className='ion-no-padding '>
          <IonRow className='ion-no-padding ion-align-items-center' style={{ paddingTop: '5px' }}>
            <IonCol size='9' className=''>
              <IonCardTitle className='attractorCard_Title'>{title}</IonCardTitle>
            </IonCol>

            <IonCol size='3' className='ion-justify-content-center'>
              {/* <IonButtons className='ion-justify-content-center'>
                            <IonButton
                              slot='icon-only'
                              fill='clear'
                              className='attractorCard_Header_Buttons'
                              onClick={() => setShowModal(true)}>
                              <IonIcon icon={informationCircleOutline} />
                            </IonButton>
                          </IonButtons> */}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardHeader>
      <IonCardContent className='' style={{ paddingLeft: '10px', paddingRight: '10px', paddingBottom: '10px' }}>
        <div className='' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
          <Chart
            options={options}
            series={series}
            type='line'
            width='100%'
            height={windowSize == 'small' ? 125 : 175}
          />
        </div>
      </IonCardContent>
    </IonCard>
  );
};
